import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import PhoneSecurityLockSymbol from '../../atoms/PhoneSecurityLockSymbol'
import { Button } from '@olxbr/ds-core'
import { breakpoints } from '../../../util/medias'

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const IconWrapper = styled.div`
  width: 110px;
  height: 110px;
  align-self: center;
  margin-top: var(--spacing-5);
  margin-bottom: var(--spacing-1);

  @media all and (max-width: ${breakpoints['mobile']}px) {
    width: 84px;
    height: 84px;
  }
`

const StyledButton = styled(Button)`
  margin-top: var(--spacing-3);
`

const PhoneValidationSuccessTemplate = ({ onSuccess, showRemovedAdsMessage }) => {
  return (
    <div className="flex items-center flex-1 flex-col">
      <ContentWrapper>
        <IconWrapper>
          <PhoneSecurityLockSymbol />
        </IconWrapper>
        <span className="typo-title-medium">Telefone verificado com sucesso</span>
        {showRemovedAdsMessage && (
          <span className="typo-body-medium mt-0-5">
            O desvínculo das demais contas também foi concluído e os anúncios nelas foram deletados.
          </span>
        )}
        <StyledButton onClick={onSuccess} size="medium" className="w-full">
          Ok
        </StyledButton>
      </ContentWrapper>
    </div>
  )
}

PhoneValidationSuccessTemplate.propTypes = {
  onSuccess: PropTypes.func,
  showRemovedAdsMessage: PropTypes.bool,
}

export { PhoneValidationSuccessTemplate }
